import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import "./index.css";
import { api } from "./api";
import { registerWebmcpTools } from "./webmcp";
import { SessionProvider } from "./stores/session";

// 尽早注册 WebMCP 工具:应用启动即注册,任意页面(含落地页)加载后即可调用,
// 不再依赖进入 /town 组件挂载;幂等,重复调用自动跳过。
registerWebmcpTools(api);

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <BrowserRouter>
      <SessionProvider>
        <App />
      </SessionProvider>
    </BrowserRouter>
  </React.StrictMode>
);
